class BundlerModal extends HTMLElement {
  constructor() {
    super()
  }

  addEventListeners() {
    this.addEventListener('bundler:error:limit', this.triggerModal.bind(this))
    this.shadowRoot.addEventListener('click', this.clickHandler.bind(this))
  }
  
  removeEventListeners() {
    this.removeEventListener('bundler:error:limit', this.triggerModal.bind(this))
    this.shadowRoot.removeEventListener('click', this.clickHandler.bind(this))
  }
  
  clickHandler(e) {
    if (e.target.dataset.action === 'close') {
      this.setAttribute('active', 'false')
      this.shadowRoot.querySelector('.bundler-modal__content').classList.remove('modal-active')
    }
  }

  connectedCallback() {
    this.init()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  triggerModal(e) {
    this.querySelector(`[slot="header"]`) ? this.querySelector(`[slot="header"]`).remove() : null
    this.querySelector(`[slot="message"]`) ? this.querySelector(`[slot="message"]`).remove() : null

    const detail = e.detail
    this.setAttribute('active', 'true')
    this.shadowRoot.querySelector('.bundler-modal__content').classList.add('modal-active')

    const header = document.createElement('span')
    header.textContent = `You've already picked ${detail.group_limit} ${detail.group_title}`
    header.setAttribute('slot', 'header')
    this.appendChild(header)

    const message = document.createElement('span')
    message.innerHTML = `Please remove one product from your box if you'd like to add <strong>${detail.product.title}</strong>`
    message.setAttribute('slot', 'message')
    this.appendChild(message)
  }

  init() {
    const template = this.querySelector('template');
    const templateContent = template.content;

    const outerStyle = document.createElement('style')
    outerStyle.textContent = `
      bundler-modal{display:grid;position:fixed;top:0;left:0;width:100%;height:100%;place-items:center;opacity:0;visibility:hidden}
      bundler-modal[active="true"]{opacity:1;visibility:visible;}
    `
    const innerStyle = document.createElement('style')
    innerStyle.textContent = `
      .bundler-modal__overlay{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.5);cursor:pointer}
      .bundler-modal__content{position:relative;background-color:#fff;display:flex;flex-direction:column;padding:50px 30px;transform:scale(.9);transition:all .15s ease;max-width:300px;gap:20px;text-align:center}
      .bundler-modal__content.modal-active{transform:scale(1)}
      .bundler-modal__close{width:44px;height:44px;border:none;background:none;-webkit-appearance:none;appearance:none;display:block;position:absolute;top:0;right:0;z-index:1;cursor:pointer;padding:0;margin:0;}
      .bundler-modal__close::before,.bundler-modal__close::after{content:"";width:50%;height:2px;background-color:#000;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(45deg)}
      .bundler-modal__close::after{transform:translate(-50%,-50%) rotate(-45deg)}
      .bundler-modal__header{font-size:1.8rem;font-weight:700}
      .bundler-modal__divider{width:calc(100% + 30px);display:block;height:2px;background-color:#000}
      .btn-styles {font-family: var(--font-body-family); text-transform: uppercase; cursor: pointer; font-size: var(--button-font-size); font-weight: 400; text-decoration: none; padding: 9px 8px 8px 8px; border-radius: 25px; width: 100%; display: flex; justify-content: center; max-width: 300px; background-color: transparent; letter-spacing: 0.1rem;}
      .btn-ghost{color: var(--btn-text-colour-dark); border: 1px solid var(--btn-text-colour-dark); width: max-content;padding:10px 20px;margin:0 auto;transition: all ease-in-out 0.2s;}
      .btn-ghost:hover{color: var(--btn-text-colour-light); border: 1px solid var(--btn-text-colour-dark);background-color:var(--btn-text-colour-dark);}
    `
      
    this.appendChild(outerStyle);
    const shadow = this.attachShadow({ mode:"open" })
    shadow.appendChild(templateContent.cloneNode(true));
    shadow.appendChild(innerStyle);
  }
}

customElements.define('bundler-modal', BundlerModal)

class ProductBundler extends HTMLElement {
  constructor() {
    super()
    this.settings = theme.bundler

    const defaultBundle = {
      active: false,
      config: this.settings.config,
      primary: this.settings.primary,
      complementary: this.settings.complementary
    }

    // set product positions
    this.totalCount = 0
    for (const group of this.settings.active_groups) {
      const productGroups = {}
      this.totalCount = this.totalCount + this.settings[`${group}_settings`].limit
      for (let i = 0; i < this.settings[`${group}_settings`].limit; i++) {
        productGroups[`product_${i + 1}`] = {}
      }
      defaultBundle[`${group}_products`] = productGroups
    }

    this.bundle = JSON.parse(localStorage.getItem('custom-bundle')) || defaultBundle
    if (this.bundle.config !== this.settings.config) {
      this.bundle = defaultBundle
      localStorage.removeItem('custom-bundle')
    }
    theme.currentBundle = this.bundle
  }

  addEventListeners() {
  }

  removeEventListeners() {
    this.removeEventListener('click', this.clickHandler.bind(this))
  }

  clickHandler(e) {
    if (e.target.dataset.action === "confirm") {
      this.addBundleToCart(e)
    }
    if (e.target.dataset.action === "clear") {
      this.removeProductFromBundle(e)
    }
    if (e.target.dataset.action === "remove") {
      this.resetBundle()
    }
    if (e.target.nodeName === "A") {
      let drawer = document.querySelector('cart-drawer')
      drawer.close()
      drawer = null
    }
  }
  
  connectedCallback() {
    this.setAttribute('active', this.bundle.active)
    this.bundleUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.bundleUpdate, (event) => {
      this.addProductToBundle(event)
    });
    this.init()
    this.addEventListeners()
    this.shadowRoot.addEventListener('click', this.clickHandler.bind(this))
  }

  disconnectedCallback() {
    if (this.bundleUpdateUnsubscriber) {
      this.bundleUpdateUnsubscriber();
    }
    this.removeEventListeners()
  }

  attributeChangedCallback(name,prev,next){
    this.classList.toggle('product-bundler__active', next === 'true')
  }

  static get observedAttributes() {
    return ['active']
  }

  addProductToBundle(e) {
    this.bundle.active = true
    this.setAttribute('active', this.bundle.active)
    
    const product = {
      id: e.detail.id,
      image: e.detail.image,
      title: e.detail.title,
      url: e.detail.url,
      group: `group_${e.detail.group}`
    }
    
    const {passed, position} = this.validateGroup(product.group)

    if (!passed) {
      console.error('[BUNDLER:ACTION:ADD] - Unable to add product, group limit reached')
      const modal = document.querySelector('bundler-modal')
      const event = new CustomEvent('bundler:error:limit', { 
        detail: {
          group_limit: theme.bundler[`${product.group}_settings`].limit,
          group_title: theme.bundler[`${product.group}_settings`].title,
          product
        }
      })
      modal.dispatchEvent(event)
      return
    }

    this.bundle[`${product.group}_products`][position] = product

    localStorage.setItem('custom-bundle', JSON.stringify(this.bundle))
    theme.currentBundle = this.bundle

    this.render(product,position.split('_')[1])

    this.updateSelected()

    document.querySelector('cart-drawer').open()
  }

  async addBundleToCart(e) {
    const btn = e.target
    const textContent = btn.textContent
    btn.classList.add('btn-loading')
    const bundleData = new FormData(this.shadowRoot.querySelector('form'))
    
    try {
      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          'X-Requested-With': 'XMLHTTPRequest'
        },
        body: bundleData,
      })
      if (!res.ok) {
        throw new Error(`[BUNDLER:ACTION:CONFIRM] - ${res.statusText}`)
      }
      const data = await res.json()
      
      const overlay = document.createElement('div')
      overlay.classList.add('confirm-overlay')
      overlay.innerHTML = `
        <div class="overlay-content">
          <img src="${this.shadowRoot.querySelector('.cart-item__image').src.split('?')[0]}" />
          <span class="overlay-text">Box selections confirmed</span>
        </div>
      `
      this.shadowRoot.appendChild(overlay)

      setTimeout(() => {
        this.resetBundle()
      },2000)
    } catch (error) {
      console.log(error)
      btn.classList.remove('btn-loading')
      btn.classList.add('btn-error')
      btn.textContent = 'Unable to add'
      setTimeout(() => {
        btn.textContent = textContent
        btn.classList.remove('btn-error')
      },2000)
    }
    btn.classList.remove('btn-loading')
  }

  removeProductFromBundle(e) {
    const position = e.target.dataset.position

    if (!position) {return}

    this.querySelector(`[slot="${position}_title"]`) ? this.querySelector(`[slot="${position}_title"]`).remove() : null
    this.querySelector(`[slot="${position}_image"]`) ? this.querySelector(`[slot="${position}_image"]`).remove() : null


    this.shadowRoot.querySelector(`[data-position="${position}"]`).classList.remove('clear-button--active')

    const positionSplit = position.split('_slot_')

    this.bundle[`${positionSplit[0]}_products`][`product_${positionSplit[1]}`] = {}

    localStorage.setItem('custom-bundle', JSON.stringify(this.bundle))
    theme.currentBundle = this.bundle

    this.updateSelected()
  }

  validateGroup(group) {
    for (const productObj of Object.entries(this.bundle[`${group}_products`])) {
      if (Object.keys(productObj[1]).length === 0) {
        return {passed: true, position: productObj[0]}
      }
    }
    return {passed: false, position: null}
  }

  validateBundle() {
    let selectedCount = 0
    for (const group of this.settings.active_groups) {
      for (const product of Object.entries(this.bundle[`${group}_products`])) {
        if (Object.keys(product[1]).length !== 0) {
          selectedCount++
        }
      }
    }
    this.querySelector(`[slot="remaining_items"]`) ? this.querySelector(`[slot="remaining_items"]`).remove() : null
    const statusEl = this.shadowRoot.querySelector('.bundle-status')
    const remainingEl = this.shadowRoot.querySelector('.remaining-items')
    const confirmEl = this.shadowRoot.querySelector('.btn-confirm')
    if (this.totalCount - selectedCount !== 0) {
      remainingEl.classList.remove('hidden')
      statusEl.classList.remove('complete')
      statusEl.textContent = 'Incomplete'
      confirmEl.classList.add('hidden')
      const span = document.createElement('span')
      if (this.totalCount - selectedCount === 1) {
        span.textContent = `${this.totalCount - selectedCount} more product`
      } else {
        span.textContent = `${this.totalCount - selectedCount} more products`
      }
      span.setAttribute('slot',`remaining_items`)
      this.appendChild(span)
    } else {
      remainingEl.classList.add('hidden')
      statusEl.classList.add('complete')
      statusEl.textContent = 'Complete'
      confirmEl.classList.remove('hidden')
    }
  }

  resetBundle() {
    localStorage.removeItem('custom-bundle')
    this.bundle = {
      active: false,
      config: this.settings.config,
      primary: this.settings.primary,
      complementary: this.settings.complementary
    }
    theme.currentBundle = this.bundle
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundler' });
  }

  render(product,position) {
    const title = document.createElement('a')
    title.textContent = product.title
    title.setAttribute('href', `${product.url}`)
    title.setAttribute('slot',`${product.group}_slot_${position}_title`)
    this.appendChild(title)

    let imagePath = product.image
    if (imagePath === '' || imagePath === null || imagePath.includes('no-image')) {
      imagePath = this.shadowRoot.querySelector(`[name="${product.group}_slot_${position}_image"] img`).src
    }

    const image = document.createElement('a')
    image.setAttribute('href', `${product.url}`)
    image.innerHTML = `
      <div class="luc-img" style="padding-top:100%">
        <img loading="lazy" class="luc-img__asset luc-img__asset--contain" src="${imagePath}" />
      </div>
    `
    image.classList.add('item-image__wrapper')
    image.setAttribute('slot',`${product.group}_slot_${position}_image`)
    this.appendChild(image)
    const clear = this.shadowRoot.querySelector(`[data-position="${product.group}_slot_${position}"]`)
    if (!clear) return
    clear.classList.add('clear-button--active')
  }

  updateSelected() {
    this.querySelector(`[slot="bundler_selected_items"]`) ? this.querySelector(`[slot="bundler_selected_items"]`).remove() : null
    const list = document.createElement('dl')
    for (const group of this.settings.active_groups) {
      for (const product of Object.entries(this.bundle[`${group}_products`])) {
        if (Object.keys(product[1]).length !== 0) {
          const div = document.createElement('div')
          div.classList.add('product-option')
          div.innerHTML += `<dd>- ${product[1].title} <button class="clear-button" data-action="clear" data-position="${group}_slot_${product[0].split("_")[1]}"></button</dd>`
          list.appendChild(div)
          const input = this.shadowRoot.querySelector(`[name="properties[_bundler_${group}_slot_${product[0].split("_")[1]}]"]`)
          input.setAttribute('value', product[1].title)
        }
      }
    }

    if (Object.keys(this.bundle.complementary).length !== 0) {
      const div = document.createElement('div')
      div.classList.add('product-option')
      div.innerHTML += `<dd>- ${this.bundle.complementary.title} (included)</dd>`
      list.appendChild(div)
      const input = this.shadowRoot.querySelector(`[name="properties[_bundler_group_complementary_slot_1]"]`)
      input.setAttribute('value', this.bundle.complementary.title)
    }
    
    list.setAttribute('slot',`bundler_selected_items`)
    this.appendChild(list)

    this.validateBundle()
  }

  init() {
    const template = document.getElementById("bundler-template");
    const templateContent = template.content;

    const style = document.createElement('style')
    style.textContent = `
      .luc-img{position:relative;width:80%;margin:0 auto}
      .luc-img__placeholder{border-radius:10px;background-color:#f5f5f5;width:100%;height:100%}
      .luc-img__asset{position:absolute;top:1rem;left:0px;width:100%;display:block;height:100%;object-fit:contain}
      @media screen and (min-width:768px) {
        .luc-medium--up{display:block;}
        .luc-small{display:none}
      }
      @media screen and (max-width:767px) {
        .luc-medium--up{display:none}
        .luc-small{display:block}
      }
      .visually-hidden{opacity:0;visibility:hidden;position:absolute;top:0;left:0;width:0;height:0;}
      .hidden{display:none}

      .bundler-main{max-width:100%;width:100%;overflow:hidden}
      .cart-items .cart-item__quantity{grid-column:2}
      .bundler-choose{width:100%;position:relative;display:flex;flex-direction:column;align-items:center}
      .items-container{display:grid;gap:10px;grid-template-columns:repeat(5,minmax(0,1fr));width:100%;}
      .item{position:relative;border:1px solid #000;text-align:center;display:flex;flex-direction:column;box-sizing:border-box}
      .item-container{width:100%;padding:10px;box-sizing:border-box;display:flex;flex-direction:column;overflow:hidden;gap:5px;background-color:#D5C3A9;}
      .clear-button--active + .item-container,.complementary-item{background-color:rgb(250,249,246);}
      .item-image{display:flex;flex-direction:column;align-items:center;width:100%;position:relative;flex-grow:1}
      ::slotted(.item-image__wrapper),.item-image__wrapper{width:60%;display:flex;flex-grow:1}
      .complementary-item ::slotted(.item-image__wrapper),.complementary-item .item-image__wrapper{width:100%;display:flex;flex-grow:1}
      .item-image__text{text-transform:uppercase;letter-spacing:2px;position:absolute;top:0;font-weight:700;font-size:1.2rem;line-height:2rem}
      .item-text{text-transform:uppercase;letter-spacing:2px;font-weight:700;font-size:1.2rem;line-height:1.6rem;display:block}
      .item-title{display:-webkit-box;line-height:2rem;height:4rem;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;font-size:1.2rem;}
      .item-title__complementary .item-title{display:block;height:unset}
      .item-title a,.item-title::slotted(a){text-decoration:none;color:#000;border-bottom:1px solid transparent}
      .item-title a:hover,.item-title::slotted(a:hover){border-bottom:1px solid #000}
      .clear-button{width:28px;height:28px;border:none;background:none;-webkit-appearance:none;appearance:none;display:block;position:absolute;top:0;right:0;z-index:1;cursor:pointer;padding:0;margin:0;opacity:0;visibility:hidden;transform:scale(0);transition:all .15s cubic-bezier(.77,.77,.54,1.24)}
      .clear-button::before,.clear-button::after{content:"";width:16px;height:1px;background-color:#000;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(45deg)}
      .clear-button::after{transform:translate(-50%,-50%) rotate(-45deg)}
      .item:hover .clear-button--active{transform:scale(1);opacity:1;visibility:visible}
      .remaining-items{font-size:1.2rem;padding:5px 10px;background-color:#000;width:100%;text-align:center;color:#fff;margin-bottom:20px;position:relative;font-weight:700}
      .remaining-items span{position:relative;z-index:1}
      .remaining-items::after{content:"";display:block;position:absolute;margin:0 auto;width:20px;height:20px;top:100%;left:50%;transform:translateX(-50%);border:16px solid transparent;border-top:12px solid #000;box-sizing:border-box;z-index:-1}
      .bundle-status{font-size:1.2rem}
      .bundle-status.complete{color:#41A06E}
      .confirm-overlay{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;background-color:rgba(0,0,0,0.4);display:grid;place-items:center;}
      .overlay-content{display:flex;flex-direction:column;gap:10px;align-items:center;background-color:#41A06E;padding:30px;width:60%;box-sizing:border-box}
      .overlay-content img{filter:invert(1);max-width:100px}
      .overlay-text{font-size:1.6rem;text-transform:uppercase;text-align:center;color:#fff}
    `
    const context = this.getAttribute('ctx')
    if (context === 'drawer') {
      style.textContent += `
        .bundler-main{max-width:370px}
        .cart-items .cart-item__quantity{grid-column:1 / -1}
        .items-container{grid-template-columns:repeat(2,minmax(0,1fr))}
        .item:last-of-type:nth-child(odd){grid-column:1 / -1;}
        .item:last-of-type:nth-child(odd) .item-container{flex-direction:row;align-items:center;gap:10px;}
        .item:last-of-type:nth-child(odd) .item-container > *{flex:1 0 0}
        .item:last-of-type:nth-child(odd) .item-container > .item-title__complementary{flex-basis:30%}
        .item:last-of-type:nth-child(odd) .item-image{height:100%}
        .item:last-of-type:nth-child(odd) .luc-img__asset{top:0;}
      `
    } 
    
    const shadow = this.attachShadow({ mode:"open" })
    shadow.appendChild(templateContent.cloneNode(true));
    shadow.appendChild(style);

    for (const group of this.settings.active_groups) {
      for (const product of Object.entries(this.bundle[`${group}_products`])) {
        if (Object.keys(product[1]).length !== 0) {
          const position = product[0].split("_")[1]
          this.render(product[1],position)
        }
      }
    }

    if (Object.keys(this.bundle.complementary).length !== 0) {
      this.render(this.bundle.complementary,1)
    }

    this.updateSelected()
  }
}

customElements.define('product-bundler', ProductBundler)